// @flow

import _ from 'lodash';

import * as EntityActions from 'app/entity/EntityActions';
import buildEntityActions from 'app/entity/utils/buildEntityActions';
import buildEntityApi from 'app/entity/utils/buildEntityApi';
import buildEntitySelectors from 'app/entity/utils/buildEntitySelectors';
import { partialWithDefault } from 'app/common/CommonUtils';
import { putJson } from 'app/common/fetch';

export const type = 'cliApp';

export const READY_TO_ACTIVATE_MESSAGE =
  "You can't promote until we've approved your integration";

const API_BASE = '/api/platform/cli/apps';

export const api = buildEntityApi(type, API_BASE, cliAppApi => {
  cliAppApi.updateApp = (app, id) => {
    return putJson(cliAppApi.modelEndpoint(`${id}`, app));
  };

  cliAppApi.promote = (appId, appVersion, changelog) => {
    return putJson(
      `${API_BASE}/${appId}/versions/${appVersion}/promote/production`,
      { changelog, is_ui: true }
    );
  };
});

export const selectors = buildEntitySelectors(type, sel => {
  sel.activationUrl = _.partial(sel.dataItem, ['']);
  sel.id = _.partial(sel.dataItem, 'id');
  sel.key = _.partial(sel.dataItem, 'key');
  sel.title = _.partial(sel.dataItem, 'title');
  sel.description = _.partial(sel.dataItem, 'description');
  sel.imageUrl = _.partial(sel.dataItem, 'image');
  sel.inviteUrl = _.partial(sel.dataItem, 'invite_url');
  sel.latestVersion = _.partial(sel.dataItem, 'latest_version');
  sel.activeVersions = partialWithDefault(sel.dataItem, ['versions'], []);
  sel.isBeta = _.partial(sel.dataItem, 'is_beta');
  sel.isPublic = _.partial(sel.dataItem, 'public');
  sel.isPending = _.partial(sel.dataItem, 'pending');
  sel.isEarlyAccess = _.partial(sel.dataItem, 'early_access');
  // For when an app is either public or early_access
  sel.isPublicIsh = _.partial(sel.dataItem, 'public_ish');

  sel.isReadyToActivate = entity => {
    const [message = ''] = sel.statusMessages(entity) || [];
    return typeof message === 'object'
      ? _.includes(
          _.map(_.flatMap(message.violations, 'results'), 'message'),
          READY_TO_ACTIVATE_MESSAGE
        )
      : message.includes(READY_TO_ACTIVATE_MESSAGE);
  };
  sel.isPrivate = entity => !sel.isPublicIsh(entity) && !sel.isPending(entity);
  // confusingly, 'versions' from the server is only active versions
  // can't change that easily now, but we can be more explicit about what we expect here
  sel.serviceId = _.partial(sel.dataItem, 'service_id');
  sel.versions = partialWithDefault(sel.dataItem, ['all_versions'], []);
});

export const actions = buildEntityActions(type, selectors, api, appActions => {
  appActions.promoteApp = (appId, appVersion, changelog) =>
    EntityActions.saveEntity(
      type,
      () => {},
      () => api.promote(appId, appVersion, changelog),
      {},
      appId
    );

  appActions.resetStatus = appId =>
    EntityActions.resetEntityStatus(type, appId);
});
